class Hotjar {
  constructor(tracker) {
    this.tracker = tracker
  }

  identifyUser(payload = {}) {
    const {
      email,
      plan,
      signedUpAt,
      userId,
      numberOfPresentations,
      country,
      lastEventStartedAt,
      abTestGroup,
      accountId,
      accountRole,
    } = payload

    this.tracker('identify', userId, {
      plan,
      email,
      signed_up_at: signedUpAt,
      number_of_presentations: numberOfPresentations,
      country,
      lastEventStartedAt,
      abTestGroup,
      accountId,
      accountRole,
    })
  }
}

export default new Hotjar(window.hj)
